import { Button } from "~/components/ui/button";
import { DialogFooter } from "~/components/ui/dialog";
import { Switch } from "~/components/ui/switch";

export interface ProjectTaskCreateFooterProps {
  readonly createMore: boolean;
  readonly creating: boolean;
  readonly projectLeadStartBusy: boolean;
  readonly projectLeadPending: boolean;
  readonly projectLeadAvailable: boolean;
  readonly canCreateTask: boolean;
  readonly onCreateMoreChange: (value: boolean) => void;
}

export function ProjectTaskCreateFooter(props: ProjectTaskCreateFooterProps) {
  return (
    <DialogFooter
      className="shrink-0 flex-row items-center justify-end border-t border-border px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-3 md:border-t-0 md:px-6 md:pb-6"
      variant="bare"
    >
      <div
        className="flex flex-wrap items-center justify-end gap-3"
        data-task-create-footer-actions
      >
        <label className="flex min-h-touch items-center gap-2 text-sm text-muted-foreground md:min-h-8">
          <Switch
            checked={props.createMore}
            disabled={props.creating || props.projectLeadPending}
            onCheckedChange={props.onCreateMoreChange}
            aria-label="Create more tasks"
          />
          Create more
        </label>
        <Button
          type="submit"
          disabled={
            !props.canCreateTask ||
            props.creating ||
            props.projectLeadStartBusy ||
            (props.projectLeadPending && props.projectLeadAvailable)
          }
        >
          {props.creating ? "Creating…" : "Create task"}
        </Button>
      </div>
    </DialogFooter>
  );
}

export interface ProjectTaskCreateProjectLeadActionProps {
  readonly busy: boolean;
  readonly pending: boolean;
  readonly available: boolean;
  readonly unavailableReason?: string | undefined;
  readonly onStart: () => void;
}

export function ProjectTaskCreateProjectLeadAction(props: ProjectTaskCreateProjectLeadActionProps) {
  return (
    <div
      className="flex max-w-sm flex-col items-end gap-1.5 text-right"
      data-task-create-project-lead-action
    >
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={props.busy || !props.available}
        title={props.unavailableReason}
        onClick={props.onStart}
      >
        {props.busy
          ? "Starting Project Lead…"
          : props.pending
            ? "Retry starting Project Lead"
            : "Plan with Project Lead"}
      </Button>
      {props.unavailableReason ? (
        <p className="text-xs leading-4 text-muted-foreground">{props.unavailableReason}</p>
      ) : null}
    </div>
  );
}
